import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Menu,
    MenuItem,
    TablePagination,
    Grid,
    Box,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import './ProductList.css'; // Import the CSS file
import AddButton from '../../Common_Components/AddButton';
import { useNavigate } from 'react-router-dom';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { MdHistory, MdMoreHoriz } from 'react-icons/md';
import FilterModal from '../../Common_Components/FilterModal';
import axiosInstance from '../../axios/axios';
import { hasPrivilege } from '../UserRole/PrevilegeCheck';
import { Toast } from '../../Common_Components/Toast';
import ConfirmDeleteModal from '../Client/ConfirmDeleteModal';
import CustomInputField from '../../Common_Components/CustomInputField';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import ResetButton from '../../Common_Components/ResetButton';
import SaveButton from '../../Common_Components/SaveButton';
const ViewStyle = {
    color: '#72E463', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#72E463', // Customize the color of the icon
    },
}
const editStyle = {
    color: '#FFC575', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#FFC575', // Customize the color of the icon
    },
}

const deleteStyle = {
    color: '#FF7575', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#FF7575', // Customize the color of the icon
    },
}

const historyStyle = {
    color: '#5C3685', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#5C3685', // Customize the color of the icon
    },
}
const ProductList = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [open, setOpen] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);

    const handleClick = (event, product) => {
        setAnchorEl(event.currentTarget);
        setSelectedProduct(product); // Store the selected product
    };
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const statusList = [{ id: 1, label: "Active" }, { id: 0, label: "Inactive" }]
    const [status, setStatus] = useState(null)
    const [products, setProducts] = useState([]);
    const [productName, setProductName] = useState('')
    const [render, setRender] = useState(0)
    const getProductList = async () => {
        const response = await axiosInstance.post('/product/List')
        const { success, products } = response.data
        if (success === true) {
            setProducts(products)
        } else {
            setProducts([])
        }
    }
    useEffect(() => {

        getProductList()
    }, [render])
    const handlenavigatetoAdd = async () => {
        navigate('/product-add')
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleDelete = async () => {
        setOpenConfirmDelete(true);  // Open the confirmation modal
        handleClose();
    };
    //for eduit page navigation
    const Editproduct = () => {
        navigate(`/product-add/${selectedProduct.PD_Id}`)
    }
    const handleConfirmDelete = async () => {
        try {
            const response = await axiosInstance.post(`/product/delete/${selectedProduct?.PD_Id}`);
            if (response.data.success) {
                setRender(render + 1)
                Toast.success(response.data.message);
                setOpenConfirmDelete(false);
                // Optionally, refresh the list or remove the client from the state
            } else {
                Toast.error(response.data.error);
                setOpenConfirmDelete(false);
            }
        } catch (error) {
            console.error('Error deleting client:', error);
        }
    };
    const handleCloseConfirmDelete = () => {
        setOpenConfirmDelete(false);
    };
    const fetchProductFilter = async () => {
        const filtersreq = {
            productName: productName,
            status: status?.id,
        }
        const response = await axiosInstance.post('/product/List', filtersreq)
        const { success, products } = response.data
        if (success === true) {
            setProducts(products)
        } else {
            setProducts([])
        }
    }

    const handleSearch = () => {
        fetchProductFilter();
    }
    const handleReset = () => {
        setProductName('')
        setStatus(null)
        getProductList();
    };
    return (
        <div className="product-list">
            <ConfirmDeleteModal
                open={openConfirmDelete}
                onClose={handleCloseConfirmDelete}
                onConfirm={handleConfirmDelete}
            />
            <FilterModal open={open} handleClose={handleCloseModal} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className='producttitle'>Products</h2>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {
                        hasPrivilege('Add Product') && <AddButton onClick={handlenavigatetoAdd} />}
                </div>
            </div>
            <Grid container spacing={2} mb={3}>
                <Grid item xs={12} md={2}>
                    <CustomInputField
                        label="Product Name"
                        value={productName}
                        onChange={(e) => setProductName(e.target.value)}
                        fullWidth
                    />
                </Grid>


                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="Status"
                        options={statusList}
                        Value={status}
                        setValue={setStatus}
                        fullWidth
                    />
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    md={2}
                    sx={{ mt: 4 }}
                    alignItems="center"
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "left", // Controls button placement
                            gap: 2, // Minimal gap between buttons
                            width: "100%",
                        }}
                    >
                        <SaveButton label="Search" onClick={handleSearch} fullWidth={false} />
                        <ResetButton label="Reset" onClick={handleReset} fullWidth={false} />
                    </Box>
                </Grid>
            </Grid>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Sl no</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Name</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Description</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Version</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Status</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {products && products.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((product, index) => (
                                <TableRow key={product.PD_Id} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                                    <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 400, fontSize: '16px', lineHeight: '18.4px', color: '#000000', alignItems: 'center' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 400, fontSize: '16px', lineHeight: '18.4px', color: '#000000', alignItems: 'center' }}>{product.PD_Name}</TableCell>
                                    <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 400, fontSize: '16px', lineHeight: '18.4px', color: '#000000', alignItems: 'center' }}>{product.PD_Description}</TableCell>
                                    <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 400, fontSize: '16px', lineHeight: '18.4px', color: '#000000', alignItems: 'center' }}>{product.PD_Version}</TableCell>
                                    <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 400, fontSize: '16px', lineHeight: '18.4px', color: '#000000', alignItems: 'center' }}>{Number(product.PD_StatusID) === 1 ? 'Active' : 'Inactive'}</TableCell>
                                    <TableCell>
                                        <MdMoreHoriz size={30} onClick={(event) => handleClick(event, product)} />

                                        <Menu
                                            id="action-menu"
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                            sx={{
                                                width: '293px',
                                                '& .MuiMenuItem-root': {
                                                    minWidth: '200px', // Increase the size of each menu item
                                                    borderBottom: '1px solid #e0e0e0', // Underline after each item
                                                    '&:last-child': {
                                                        borderBottom: 'none', // Remove underline from the last item
                                                    },
                                                },
                                            }}
                                        >
                                            {/* <MenuItem
                                            onClick={handleView}
                                            sx={ViewStyle}
                                        >
                                            <Visibility sx={{ mr: 1 }} />
                                            View
                                        </MenuItem> */}
                                            {
                                                hasPrivilege('Edit Product') && <MenuItem
                                                    //onClick={() => navigate(`/product-add/${product.PD_Id}`)}
                                                    onClick={() => Editproduct()}
                                                    sx={editStyle}
                                                >
                                                    <Edit sx={{ mr: 1 }} />
                                                    Edit
                                                </MenuItem>
                                            }

                                            {
                                                hasPrivilege('Delete Product') && <MenuItem
                                                    onClick={handleDelete}
                                                    sx={deleteStyle}
                                                >
                                                    <Delete sx={{ mr: 1 }} />
                                                    Delete
                                                </MenuItem>
                                            }
                                            {/* <MenuItem onClick={handleDelete} sx={historyStyle}>
                                            <MdHistory size={'25'} style={{ marginRight: 7 }} /> History
                                        </MenuItem> */}
                                        </Menu>
                                    </TableCell>


                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={products.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    );
};

export default ProductList;
